import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './core/guards/auth-guard.service';
import { BootstrapGuard, AlreadyBootstrappedGuard } from './core/guards/bootstrap.guard';
import { AppMainComponent } from './layouts/app.main/app.main.component';
import { AppUnauthorizedComponent } from './layouts/app.unauthorized/app.unauthorized.component';
import { AppNotfoundComponent } from './layouts/app.notfound/app.notfound.component';
import { RumIntegrationService } from './services/rum-integration.service';

const routes: Routes = [
  {
    path: '',
    component: AppMainComponent,
    canActivate: [BootstrapGuard, AuthGuard],
    runGuardsAndResolvers: 'always',
    children: [
      {
        path: '',
        redirectTo: 'sbvp',
        pathMatch: 'full',
      },
      {
        path: 'sbvp',
        loadChildren: () => import('./modules/sbvp/sbvp.module').then(x => x.SBVPModule),
      },
    ],
  },
  {
    path: 'bootstrap',
    canActivate: [AlreadyBootstrappedGuard],
    loadChildren: () => import('./modules/bootstrap/bootstrap.module').then(m => m.BootstrapModule),
  },
  {
    path: 'login',
    loadChildren: () => import('./modules/account/account.module').then(x => x.AccountModule),
  },
  {
    path: 'error',
    loadChildren: () => import('./shared/error/module').then(m => m.ErrorModule),
  },
  { path: 'not-authorized', component: AppUnauthorizedComponent },
  { path: 'not-found', component: AppNotfoundComponent },
  { path: '**', component: AppNotfoundComponent, pathMatch: 'full' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'enabled',
      preloadingStrategy: PreloadAllModules,
      useHash: true,
    }),
  ],
  providers: [RumIntegrationService],
  exports: [RouterModule],
})
export class AppRoutingModule {}
